import type { PartialMessages } from "../messages";

export const tr: PartialMessages = {
  "status.syncing": "Eşitlendi", "status.connecting": "Bağlanıyor", "status.full": "Dolu", "status.closed": "Bağlantı kesildi",
  "toast.connecting": "Bağlanıyor…", "toast.reconnecting": "Bağlantı koptu. Yeniden deneniyor…",
  "toast.retrying": "Birazdan tekrar denenecek.", "toast.busy": "Şu an yoğunluk var",
  "notice.mapChanged": "{name} haritayı değiştirdi",
  "hint.place": "Koymak için tıkla, yön vermek için sürükle (Esc iptal eder)",
  "kind.objective": "Hedef", "kind.rally": "Toplanma", "kind.enemy": "Düşman", "kind.loot": "Ganimet",
  "kind.extract": "Çıkış", "kind.danger": "Tehlike", "kind.self": "Ben", "kind.ping": "Burası!",
  "hint.objective": "Nereye gidiyorsunuz", "hint.rally": "Toplanma noktası",
  "hint.enemy": "Gördüğün yöne çevir", "hint.loot": "Nadir konteynerler, cesetler",
  "hint.extract": "Planlanan çıkış", "hint.danger": "Mayın, keskin nişancı, açık alan",
  "hint.self": "Konumun. Yenisini koyunca eskisi silinir",
  "hint.ping": "25 saniye sonra kaybolan geçici işaret",
  "tool.clearMine": "Benimkileri sil", "tool.clearMineHint": "Koyduğun tüm işaretleri kaldırır",
  "sidebar.map": "Harita (herkes için)", "sidebar.styleSvg": "Çizim", "sidebar.styleTile": "Uydu",
  "sidebar.floors": "Kat (sadece senin görünümünü değiştirir)", "sidebar.groundFloor": "Zemin",
  "sidebar.floorNote": "Diğer katlardaki işaretler soluk görünür.",
  "sidebar.members": "{count} kişi", "sidebar.you": "sen", "sidebar.guest": "misafir",
  "sidebar.clearAll": "Tüm işaretleri sil", "sidebar.openWindow": "Ayrı pencerede aç (sadece ben)",
  "sidebar.invite": "Birini davet et", "sidebar.help": "Nasıl kullanılır", "sidebar.feedback": "Geri bildirim gönder",
  "sidebar.mapData": "Harita verisi", "sidebar.license": "Lisans", "sidebar.licenseNote": "yalnızca ticari olmayan kullanım",
  "sidebar.room": "Oda",
  "pin.facing": "Yön", "pin.floor": "Kat", "pin.map": "Harita", "pin.noFacing": "Yön yok",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Not ekle (örn. üçüncü kattaki pencere)",
  "pin.removeMine": "Bu işareti sil", "pin.removeOther": "Başkasının işaretini sil", "pin.close": "Kapat",
  "compass.n": "K", "compass.ne": "KD", "compass.e": "D", "compass.se": "GD",
  "compass.s": "G", "compass.sw": "GB", "compass.w": "B", "compass.nw": "KB",
  "handoff.title": "Ayrı pencerede aç",
  "handoff.lede": "Kendin için bir bağlantı. Aynı odayı tarayıcıda açar; böylece Discord ekran paylaşımını göstermeye devam ederken harita başka bir ekranda durur.",
  "handoff.open": "Bu bilgisayarın tarayıcısında aç", "handoff.or": "Başka bir cihazda",
  "handoff.codeHint": "O cihazda {host}/j/ adresine gir ve yukarıdaki kodu yaz.",
  "handoff.copy": "Bağlantıyı kopyala", "handoff.copied": "Kopyalandı",
  "handoff.copyFailed": "Yukarıda seçildi — Ctrl+C'ye bas",
  "handoff.expiry": "Bu bağlantı bir kez çalışır. {time} sonra geçersiz olur.",
  "handoff.warn": "Başkasına verme: açıldığında tükenir. Onun için „Birini davet et“ var.",
  "handoff.creating": "Bağlantı oluşturuluyor…", "handoff.failed": "Bağlantı oluşturulamadı",
  "invite.title": "Birini davet et",
  "invite.lede": "Sesli kanalda olmayan birini çağır. Bir isim yazar ve işaret koyabilir.",
  "invite.copy": "Bağlantıyı kopyala", "invite.warn": "Bu bağlantıyı bilen herkes katılabilir. Herkese açık yerde paylaşma.",
  "invite.budget": "{left} kişi daha, {time} sonra dolar (kullanılan {used}/{max}).",
  "invite.revoke": "Bu bağlantıyı hemen iptal et", "invite.revoked": "Bağlantı iptal edildi.",
  "invite.creating": "Bağlantı oluşturuluyor…", "invite.failed": "Bağlantı oluşturulamadı",
  "invite.revokeFailed": "İptal edilemedi",
  "join.title": "Haritaya katıl",
  "join.lede": "Bir baskın haritasına davet edildin. Görünecek bir isim seç — işaretlerinde bu yazacak.",
  "join.name": "İsim", "join.go": "Katıl", "join.joining": "Katılıyor…", "join.failed": "Katılınamadı",
  "feedback.title": "Yazara yaz", "feedback.request": "Öneri", "feedback.bug": "Hata",
  "feedback.other": "Diğer", "feedback.requestHint": "Şöyle olsa güzel olurdu…",
  "feedback.bugHint": "Bir şeyler ters", "feedback.otherHint": "Ne olursa",
  "feedback.placeholder": "örn. sadece ok değil çizgi de çizmek istiyorum / Streets'te katlar değişmiyor",
  "feedback.note": "Yanıt verebilmek için Discord adın ve kimliğin de gönderilir.",
  "feedback.send": "Gönder", "feedback.sending": "Gönderiliyor…", "feedback.sent": "Gönderildi. Teşekkürler!",
  "feedback.failed": "Gönderilemedi",
  "time.minutes": "{n} dk", "time.hoursMinutes": "{h} sa {m} dk",
  "error.roomFull": "Bu oda dolu",
  "error.tooManyWindows": "Bu oda için çok fazla pencere açık. Birini kapat.",
  "error.serverFull": "Sunucu dolu", "error.session": "Oturumun geçersiz. Yeniden aç.",
  "error.handoffSpent": "Bu bağlantı çalışmaz. Tek kullanımlıktır ve yalnızca onu oluşturan içindir. Birini çağırmak için haritadan davet bağlantısı oluştur.",
  "error.inviteSpent": "Bu davet bağlantısı artık geçerli değil. Yenisini iste.",
  "error.inviteNotOwner": "Bağlantıyı yalnızca oluşturan kişi iptal edebilir",
  "error.noRoom": "Oda belirtilmedi", "error.needName": "Bir isim yaz",
  "error.tooShort": "Biraz daha yaz", "error.tooLong": "Çok uzun",
  "error.badKind": "Geçersiz kategori",
  "error.rateLimited": "Çok fazla mesaj. Yaklaşık 10 dakika bekle.",
  "error.busy": "Yoğunluk var. Birazdan tekrar dene.",
  "error.sendFailed": "Gönderilemedi. Daha sonra dene.",
  "error.feedbackClosed": "Geri bildirim şu an kapalı",
  "error.sessionGone": "Asıl oturum sona erdi. Etkinliği yeniden aç.",
  "landing.tagline1": "Bir Tarkov haritasını",
  "landing.tagline2": "Discord'daki herkesle paylaş ve üzerinde konuşun.",
  "landing.install": "Discord'a ekle",
  "landing.installNote": "Ücretsiz. Sesli kanaldaki roket simgesinden açılır.",
  "landing.body": "Görüşmedeki herkes aynı haritayı görür. Tıklayınca işaret koyulur; koyarken sürüklersen yön oku da eklenir — yalnızca nerede değil, ne tarafa olduğunu da gösterirsin.",
  "landing.point1": "Aynı görüşmede olmak yeter. Kod girmeye gerek yok",
  "landing.point2": "13 haritanın hepsi. Çizim veya uydu, üstelik katlar",
  "landing.point3": "İşaretler yerinde kalır, sonra bakabilirsin",
  "landing.point4": "Görüşmede olmayanlar davet bağlantısıyla katılır",
  "landing.footNote": "Oyuna hiç dokunmaz. Dosya yok, bellek yok, oyunun üstüne çizilen hiçbir şey yok. Her işareti insan eliyle koyar.",
  "landing.footCredit": "Hobi projesi, ücretsiz çalışıyor. Harita verileri {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov, Battlestate Games Limited ürünüdür; bu, onlarla bağlantısı olmayan gayriresmî bir hayran projesidir.",
  "landing.updates": "Güncellemeler", "landing.allUpdates": "Tüm güncellemeler",
  "boot.connecting": "Discord'a bağlanılıyor…", "boot.failedTitle": "Başlatılamadı",
};
